"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Dialog: function() {
        return _index.Dialog;
    },
    renderDialog_unstable: function() {
        return _index.renderDialog_unstable;
    },
    useDialogContextValues_unstable: function() {
        return _index.useDialogContextValues_unstable;
    },
    useDialog_unstable: function() {
        return _index.useDialog_unstable;
    }
});
const _index = require("./components/Dialog/index");
